import { submitFeedback as bridgeSubmitFeedback } from './feedback-bridge';
import { FeedbackResponse } from '../types/feedback';

export interface FeedbackData {
  name?: string;
  email: string;
  subject?: string;
  message: string;
  feedbackType: string;
}

export class FeedbackService {
  /**
   * Submit feedback to the backend API
   * @param data The feedback data to submit
   * @returns Promise with the response from the API
   */
  static async submitFeedback(data: FeedbackData): Promise<FeedbackResponse> {
    return bridgeSubmitFeedback(data);
  }
}

export default FeedbackService;
